module.exports = global["$"] = require("-!/var/lib/jenkins/workspace/edmunds-groundwork-assets/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/jquery/dist/jquery.js
// module id = 338
// module chunks = 36